import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from "../../Paginas/Login";
import Inicio from "../Inicio";
import PrivateRoute from "./PrivateRoute";
import PublicRouter from "./PublicRouter";
import Solicitud from "../../Paginas/Solicitud";
import RegistroPagina from "../../Paginas/RegistroPagina";
import RecuperarContrasena from "../../Paginas/RecuperarContrasena";
import RestablecerContrasena from "../../Paginas/RestablecerContrasena";
import BorrarCuenta from "../../Paginas/BorrarCuenta";

export default function AppRouter()
{
    return (
        <>
            <Router>
                <Routes>
                    <Route exact path="/" element={<PublicRouter><Login></Login></PublicRouter>}></Route>
                    <Route exact path="/login" element={<PublicRouter><Login></Login></PublicRouter>}></Route>
                    <Route exact path="/home" element={<PrivateRoute><Inicio></Inicio></PrivateRoute> }></Route>
                    <Route path="/*" element={<PublicRouter><Login></Login></PublicRouter>}></Route>
                    <Route exact path="/solicitud" element={<PublicRouter><Solicitud></Solicitud></PublicRouter>}></Route>
                    <Route exact path="/RecuperarContrasena" element={<PublicRouter><RecuperarContrasena></RecuperarContrasena></PublicRouter>}></Route>
                    <Route exact path="/RestablecerContrasena" element={<PublicRouter><RestablecerContrasena></RestablecerContrasena></PublicRouter>}></Route>
                    <Route exact path="/BorrarCuenta" element={<PublicRouter><BorrarCuenta></BorrarCuenta></PublicRouter>}></Route>
                    <Route exact path="/RegistroPagina/:id/:casilla" element={<PublicRouter><RegistroPagina></RegistroPagina></PublicRouter>}></Route>
                </Routes>
            </Router>
        </>
    )
}
